export const environment = {
  production: true,
  // SERVER_URL: "https://demo.services.gov.go.tz:9082",
  GRAPHQL_URL: "https://huduma.serikali.go.tz/kiungo/",
  AUTH_SERVER_URL: "https://huduma.serikali.go.tz/tokeni-uaa/",
  FILE_SERVER_URL: "https://huduma.serikali.go.tz:9081/tgsd_file_media",


  // GRAPHQL_URL: "https://tgsd3.all.co.tz/kiungo/",
  // AUTH_SERVER_URL: "https://tgsd3.all.co.tz/tokeni-uaa/",
  // FILE_SERVER_URL: "https://tgsd3.all.co.tz:9092/tgsd_file_media",

  CLIENT_ID: "680c290a5480a7a58e27",
  CLIENT_SECRET: "50039db47fe4862f57cefee80881b7fb00d2a7ce",
  SESSION_TIMEOUT: 1800000
};
